const hotel = {
    getlist: 'hotel/getlist',
    add: 'hotel/add',
    update: 'hotel/update',
    remove: 'hotel/remove',
    get: 'hotel/get',
    getall: 'hotel/getall',
}
export default hotel
